import styled from 'styled-components'
import { Button } from '@salesforce/design-system-react'

export const ButtonWrapper = styled(Button)`
  width: 100%;
`
